import PortalAppService from "../../../application/platform/portal-app-service";
import { ISearchRequest } from "../../../model/base/request/search-request";
import { ACTION_TYPES, useSearchResultsDispatch } from "./search-results-context";

export const useSearchResultsController = () => {
    const dispatch = useSearchResultsDispatch();

    async function searchPortal(params: ISearchRequest) {
        try {
            const searchResults = await PortalAppService.searchPortal(params);
            dispatch({
                type: ACTION_TYPES.SET_SEARCH_RESULTS,
                payload: searchResults,
            });
        } catch (error) {
            console.error('Error searching portal:', error);
        }
    }

    function setSearchTerm(term: string) {
        dispatch({
            type: ACTION_TYPES.SET_SEARCH_TERM,
            payload: term,
        });
    }

    return {
        searchPortal,
        setSearchTerm
    };
};
